// extracted by mini-css-extract-plugin
export default {"pageNotFound":"_404_pageNotFound__YVS6Z","head":"_404_head__3JybL","h2":"_404_h2__mdF5J","h3":"_404_h3__csNZ2"};